import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
} from "mdb-react-ui-kit";

const SessionExpiredModal = ({ show, onCancel, onConfirm }) => {
  return (
    <MDBModal open={show} staticBackdrop centered>
      <MDBModalDialog size="sm">
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Session Expired</MDBModalTitle>
          </MDBModalHeader>

          <MDBModalBody className="text-center">
            <p className="mb-0">
              Your token is expired.
              <br />
              Please login again.
            </p>
          </MDBModalBody>

          <MDBModalFooter className="justify-content-center">
            <MDBBtn color="light" onClick={onCancel}>
              Cancel
            </MDBBtn>
            <MDBBtn color="danger" onClick={onConfirm}>
              Yes
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

export default SessionExpiredModal;
